// extracted by mini-css-extract-plugin
export default {"summary":"Iv","separator":"Jv","title":"Kv","note":"Lv","items_wrapper":"Mv","member_perk":"Nv","info":"Ov","extraQuestionsContain":"Pv","h1":"Qv","p":"Rv","btn":"Sv","stickyButton":"Tv"};
    if(module.hot) {
      // 1743628922750
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  